import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {DocumentModel} from '../../../api/model/document.model';
import {DocumentConverter} from '../../../api/converter/document.converter';
import {DocumentDataService} from './documentData.service';

@Injectable({ providedIn: 'root' })
export class DocumentDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<DocumentModel, DocumentConverter> {
    constructor(dataService: DocumentDataService, converter: DocumentConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): DocumentModel {
        return new DocumentModel();
    }
}
